import { createAction } from './base';

const GetProjectAction = createAction('GetProjectAction');
const GetProjectHeaderAction = createAction('GetProjectHeaderAction');
const FetchProjectsByTypeAction = createAction('FetchProjectsByTypeAction');
const UnloadProjectAction = createAction('UnloadProjectAction');
const UpdateConsultationFormAction = createAction('UpdateConsultationFormAction');
const SaveCommentAction = createAction('SaveCommentAction');
const AddCommentOpinionAction = createAction('AddCommentOpinionAction');
const RemoveCommentOpinionAction = createAction('RemoveCommentOpinionAction');
const AddProjectOpinionAction = createAction('AddProjectOpinionAction');
const RemoveProjectOpinionAction = createAction('RemoveProjectOpinionAction');
const GetBudgetVoteProjectsAction = createAction('GetBudgetVoteProjectsAction');
const FetchArchiveProjectsByTypeAction = createAction('FetchArchiveProjectsByTypeAction');
const GenerateNewAuthorizeCodeAction = createAction('GenerateNewAuthorizeCodeAction');

function getProject(id, clientId = null) {
	return {
		type: GetProjectAction.Request,
		payload: { id, clientId }
	};
}
function getProjectHeader(id) {
	return {
		type: GetProjectHeaderAction.Request,
		payload: id
	};
}
function fetchProjectsByType(projectType, filter) {
	return {
		type: FetchProjectsByTypeAction.Request,
		payload: {
			projectType: projectType,
			isActual: true,
			...filter
		}
	};
}
function unloadProject() {
	return {
		type: UnloadProjectAction.Request
	};
}
function updateConsultationForm(projectId, consultationForms, userData = null, authorizeCode = null) {
	return {
		type: UpdateConsultationFormAction.Request,
		payload: { projectId, consultationForms, userData, authorizeCode }
	};
}
function saveComment(comment) {
	return {
		type: SaveCommentAction.Request,
		payload: comment
	};
}

function addCommentOpinion(id, type) {
	return {
		type: AddCommentOpinionAction.Request,
		payload: {
			id: id,
			type: type
		}
	};
}
function removeCommentOpinion(id) {
	return {
		type: RemoveCommentOpinionAction.Request,
		payload: {
			id: id
		}
	};
}

function addProjectOpinion(id, type) {
	return {
		type: AddProjectOpinionAction.Request,
		payload: {
			id: id,
			type: type
		}
	};
}
function removeProjectOpinion(id) {
	return {
		type: RemoveProjectOpinionAction.Request,
		payload: {
			id: id
		}
	};
}
function getBudgetVoteProjects(year, filter) {
	return {
		type: GetBudgetVoteProjectsAction.Request,
		payload: {
			year,
			filter
		}
	};
}

function fetchArchiveProjectsByType(projectType, filter) {
	return {
		type: FetchArchiveProjectsByTypeAction.Request,
		payload: {
			projectType: projectType,
			isActual: false,
			...filter
		}
	};
}
function generateNewAuthorizeCode(projectId, userData) {
	return {
		type: GenerateNewAuthorizeCodeAction.Request,
		payload: {
			projectId,
			userData
		}
	};
}

export const ProjectActionCreators = {
	getProject,
	getProjectHeader,
	fetchProjectsByType,
	unloadProject,
	updateConsultationForm,
	saveComment,
	addCommentOpinion,
	removeCommentOpinion,
	addProjectOpinion,
	removeProjectOpinion,
	getBudgetVoteProjects,
	fetchArchiveProjectsByType,
	generateNewAuthorizeCode
};

export const ProjectActions = {
	GetProjectAction,
	GetProjectHeaderAction,
	FetchProjectsByTypeAction,
	UnloadProjectAction,
	UpdateConsultationFormAction,
	SaveCommentAction,
	AddCommentOpinionAction,
	RemoveCommentOpinionAction,
	AddProjectOpinionAction,
	RemoveProjectOpinionAction,
	GetBudgetVoteProjectsAction,
	FetchArchiveProjectsByTypeAction,
	GenerateNewAuthorizeCodeAction
};
